import { RECEIVABLE_PAYMENT_METHODS } from "@artisancode/api-types";
import { z } from "zod";

export const paymentSchema = z.object({
  date: z.string().min(1, "Tanggal wajib diisi"),
  amount: z.number().min(1, "Nominal wajib diisi"),
  method: z.enum(RECEIVABLE_PAYMENT_METHODS),
  verified: z.boolean(),
  notes: z.string().optional(),
});

export type PaymentFormValues = z.infer<typeof paymentSchema>;

export const defaultPaymentValues: PaymentFormValues = {
  date: new Date().toISOString().slice(0, 10),
  amount: 0,
  method: "cash",
  verified: false,
  notes: "",
};

export const metaSchema = z.object({
  collectorName: z.string().optional(),
  notes: z.string().optional(),
});

export type MetaFormValues = z.infer<typeof metaSchema>;
